import "../css/main.css";
import { toggleHamburger } from "./toggleHamburger";
import { accordion } from "./accordion";
import { tabMenu } from "./tabMenu";
import { initializeViewport } from "./initializeViewport";
import { initBackToTopButton } from "./backToTop";

document.addEventListener("DOMContentLoaded", () => {
  toggleHamburger("js-hamburger", "js-spmenu", 1024);
  accordion();
  tabMenu();
  initializeViewport();
  initBackToTopButton();
});
